import AppEncyclopediaHeader from '../app-encyclopedia-header'
import AppEncyclopediaList from '../app-encyclopedia-list'
import AppEncyclopediaPagination from '../app-encyclopedia-pagination'
import AppFavManager from '../app-fav-manager/'

export default
{
    components:
    {
        AppEncyclopediaHeader,
        AppEncyclopediaList,
        AppEncyclopediaPagination,
        AppFavManager
    },

    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            isListActive: false,
            isFullScreen: false,
            isZoom: false,
            isCursorVisible: false,
            scaleView: 1,
            activeIndex: 0,
            mouse: {
                x: 0,
                y: 0,

                ratio: {
                    x: 0,
                    y: 0
                },
                smooth: {
                    x: 0,
                    y: 0
                }
            },
            translation: {
                x: 0,
                y: 0,
                smooth: {
                    x: 0,
                    y: 0
                }
            }
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('window:tick', this.onTick)
        this.eventHub.$on('keydown', this.onKeydown)
    },

    mounted()
    {
        // this.$pagination = this.$el.querySelector('.js-pagination')
        this.$cursor = this.$el.querySelector('.js-cursor')
        this.$zoom = this.$el.querySelector('.js-zoom')
        this.$translate = this.$el.querySelector('.js-translate')

        this.$img = this.$el.querySelectorAll('.js-image')

        this.onResize()

        this.onActiveIndexChange()

        this.$emit('page:ready')
    },

    destroyed()
    {
        this.eventHub.$off('keydown', this.onKeydown)
        this.eventHub.$off('window:tick', this.onTick)
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods:
    {
        onToggleList()
        {
            this.isListActive = !this.isListActive
            this.$el.classList.toggle('is-list-active')
        },

        onToggleFullScreen()
        {
            if(this.isFullScreen && this.isZoom)
            {
                this.onToggleZoom()
            }

            this.isFullScreen = !this.isFullScreen
            this.$el.classList.toggle('is-fullscreen')

            if(!this.isFullScreen)
            {
                this.isCursorVisible = false
            }


            this.onResize()
        },

        onItemClick(index)
        {
            this.activeIndex = index
            this.onActiveIndexChange()
        },

        onPrevItem()
        {
            if(this.activeIndex > 0)
            {
                this._prevIndex = this.activeIndex
                this.activeIndex -= 1
                this.onActiveIndexChange()
            }
        },

        onNextItem()
        {
            if(this.activeIndex < this.content.post.images.length - 1)
            {
                this._prevIndex = this.activeIndex
                this.activeIndex += 1
                this.onActiveIndexChange()
            }
        },

        onActiveIndexChange()
        {
            if(this.$img[this.activeIndex].getAttribute('data-loaded') === 'false')
            {
                const img = new Image()

                img.onload = () =>
                {
                    this.$img[this.activeIndex].src = img.src
                    this.$img[this.activeIndex].setAttribute('data-loaded', true)
                }

                img.src = this.$img[this.activeIndex].getAttribute('data-src')
            }

            // if(this._prevIndex > this.activeIndex)
            // {
            //     this.$el.classList.add('is-prev')
            //     this.$el.classList.remove('is-next')
            // }
            // else
            // {
            //     this.$el.classList.remove('is-prev')
            //     this.$el.classList.add('is-next')
            // }

        },

        onKeydown(keycode)
        {
            if(keycode === 37)
            {
                this.onPrevItem()
            }
            else if(keycode === 39)
            {
                this.onNextItem()
            }
        },

        onResize()
        {
            this.scaleView = this.isFullScreen ? 1 : (this.$root.window.height - 135) / this.$root.window.height

            this._itemWidth = (this.$root.window.width / 100) * 15
        },

        onMouseMove(event)
        {
            this.mouse.x = event.pageX
            this.mouse.y = event.pageY

            // give a ratio between -1 & 1
            this.mouse.ratio.x = ((this.mouse.x / this.$root.window.width) - 0.5) * 2
            this.mouse.ratio.y = ((this.mouse.y / this.$root.window.height) - 0.5) * 2
        },

        onTick()
        {
            this.mouse.smooth.x += (this.mouse.x - this.mouse.smooth.x) * .1
            this.mouse.smooth.y += (this.mouse.y - this.mouse.smooth.y) * .1

            this.translation.x = this.mouse.ratio.x * (this.$root.window.width * 1.7 - this.$root.window.width) * .5 * (this.isZoom ? 1 : 0)
            this.translation.y = this.mouse.ratio.y * (this.$root.window.height * 1.7 - this.$root.window.height) * .5 * (this.isZoom ? 1 : 0)

            this.translation.smooth.x += (this.translation.x - this.translation.smooth.x) * .1
            this.translation.smooth.y += (this.translation.y - this.translation.smooth.y) * .1

            this.$translate.style.transform = 'translateX(' + -this.translation.smooth.x.toFixed(2) + 'px) translateY(' + -this.translation.smooth.y.toFixed(2) + 'px) translateZ(0)'

            if(this.isFullScreen)
            {
                this.$cursor.style.transform = 'translateX(' + this.mouse.smooth.x + 'px) translateY(' + this.mouse.smooth.y + 'px) translateZ(0)'
            }

        },

        onToggleZoom()
        {
            if(!this.isFullScreen)
            {
                return
            }

            this.isZoom = !this.isZoom
            this.$el.classList.toggle('is-zoom')

            if(this.isZoom)
            {
                this.isCursorVisible = true
                this.$zoom.style.transform = 'translateX(0) translateY(0) scale(1.7) translateZ(0)'
            }
            else
            {
                this.$zoom.style.transform = 'translateX(0) translateY(0) scale(1) translateZ(0)'
            }
        },

        onTouchDown(event)
        {
            this._startX = event.touches[0].pageX
        },

        onTouchMove(event)
        {
            this._currX = event.touches[0].pageX
        },

        onTouchEnd()
        {
            if(Math.abs(this._currX - this._startX) > 10)
            {
                if(this._currX < this._startX)
                {
                    this.onNextItem()
                }
                else
                {
                    this.onPrevItem()
                }
            }

        },

        onControlEnter()
        {
            this.onHideCursor()
        },

        onControlLeave()
        {
            this.onShowCursor()
        },

        onShowCursor()
        {
            if(this.isFullScreen)
            {
                this.isCursorVisible = true
            }
        },

        onHideCursor()
        {
            this.isCursorVisible = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-encyclopedia-detail/script.js